import PrioritySelect from './PrioritySelect';

export default PrioritySelect;



// WEBPACK FOOTER //
// ./src/components/prioritySelect/index.js